import http from '@windsor-telecom-management/client-core/src/http'

/**
 * @type {AxiosInstance}
 */
const client = http()

/**
 * @type {string[]}
 */
const AUTH_ROUTES = ['/auth/me', '/auth/login', '/auth/logout']

/**
 * @type {string}
 */
const SESSION_KEY = 'x-user-session-key'

/**
 * @type {string}
 */
let lastSessionKey

/**
 * @type {boolean}
 */
let sessionChanged = false

async function checkResponseHeaders (response) {
    const headers = response?.headers ?? {}
    const config = response?.config ?? {}
    let sessionKey = headers[SESSION_KEY]

    if (AUTH_ROUTES.includes(config.url)) {
        lastSessionKey = undefined
    }

    if (!sessionChanged && sessionKey) {
        if (lastSessionKey && (lastSessionKey !== sessionKey)) {
            sessionChanged = true
            await alert('Your session has changed, the page needs to be refreshed.')
            window.location.reload()
            return
        }

        lastSessionKey = sessionKey
    }
}

client.interceptors.response.use(async (response) => {
    await checkResponseHeaders(response)
    return response
}, async (error) => {
    await checkResponseHeaders(error?.response)
    return Promise.reject(error)
})

export default client
